import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { combineReducers } from 'redux';
import { apiSlice } from './api/apiSlice';
import { modals } from '../controls/modals/reducer';
import { siteInfoInfoReducer } from '../reducers/siteInfo';
import { userInfoReducer } from '../reducers/userInfo';
import { trialInfoReducer } from '../reducers/trialInfo';
import { localizationReducer } from '../reducers/localization';
import { checkoutInfoReducer } from '../reducers/checkoutInfo';

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  modals,
  siteInfo: siteInfoInfoReducer,
  userInfo: userInfoReducer,
  trialInfo: trialInfoReducer,
  localization: localizationReducer,
  checkoutInfo: checkoutInfoReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: process.env.NODE_ENV === 'development',
});

setupListeners(store.dispatch);
